/* Yearpins standard cart POST attribution. No requests, delays, checkout redirects or analytics. */
(function () {
  'use strict';
  if (window.YPOrderAttribution || window.top !== window.self ||
      !['yearpins.com', 'www.yearpins.com'].includes(window.location.hostname)) return;
  var selector = 'form#cart, form#CartDrawer-Form, form#cart-notification-form';
  var sourceKeys = ['yp_first_source_medium', 'yp_latest_source_medium', 'yp_landing_page'];
  function values() {
    var out = {
      yp_first_source_medium: 'unknown / unavailable',
      yp_latest_source_medium: 'unknown / unavailable',
      yp_landing_page: 'unknown',
      yp_checkout_entry_page: 'unknown',
      yp_order_entry: 'website_cart'
    };
    try {
      var url = new URL(window.location.href);
      out.yp_checkout_entry_page = url.origin + url.pathname;
      var api = window.YPSourceAttribution;
      var current = api && api.getFields();
      if (current) sourceKeys.forEach(function (key) {
        if (typeof current[key] === 'string' && current[key].trim() && current[key].length <= 4096) {
          out[key] = current[key];
        }
      });
    } catch (_) { /* Attribution failure must not prevent checkout. */ }
    return out;
  }
  function isCart(form) {
    if (!form || form.tagName !== 'FORM' ||
        !['cart', 'CartDrawer-Form', 'cart-notification-form'].includes(form.id)) return false;
    try {
      var action = new URL(form.action, window.location.href);
      return action.origin === window.location.origin && /\/cart\/?$/.test(action.pathname) &&
        String(form.method).toLowerCase() === 'post';
    } catch (_) { return false; }
  }
  function fill(form, data) {
    if (!isCart(form)) return;
    try {
      var current = values();
      Object.keys(current).forEach(function (key) {
        var name = 'attributes[' + key + ']';
        var inputs = Array.from(form.querySelectorAll('input')).filter(function (el) { return el.name === name; });
        var input = inputs.shift();
        inputs.forEach(function (duplicate) { duplicate.remove(); });
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden'; input.name = name;
          form.appendChild(input);
        }
        input.value = current[key];
        if (data) data.set(name, current[key]);
      });
    } catch (_) { /* Leave the original checkout action intact. */ }
  }
  function refresh() {
    document.querySelectorAll(selector).forEach(function (form) { fill(form); });
  }
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest('[name="checkout"]');
    // .form resolves buttons placed outside the form via form="cart" or form="CartDrawer-Form".
    if (button) fill(button.form);
  }, true);
  document.addEventListener('submit', function (event) { fill(event.target); }, true);
  document.addEventListener('formdata', function (event) { fill(event.target, event.formData); }, true);
  document.addEventListener('visitorConsentCollected', refresh);
  window.addEventListener('pageshow', refresh);
  window.YPOrderAttribution = { refresh: refresh };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
